<template>
  <v-main>
    <v-snackbar
      top
      z-index="100000"
      color="error"
      v-model="snackbar.show"
      :timeout="10000"
    >
      {{ snackbar.msg }}
    </v-snackbar>
    <LibHomeSectionBanner />
    <LibHomeSectionDesc />
    <LibHomeSectionAxis />
    <LibHomeSectionIcons />
    <LibHomeSectionInfo />
    <LibHomeSectionNewsletter />
  </v-main>
</template>

<script>
import LibHomeSectionBanner from "@/components/library/main/LibHomeSectionBanner.vue";
import LibHomeSectionDesc from "@/components/library/main/LibHomeSectionDesc.vue";
import LibHomeSectionAxis from "@/components/library/main/LibHomeSectionAxis.vue";
import LibHomeSectionIcons from "@/components/library/main/LibHomeSectionIcons.vue";
import LibHomeSectionNewsletter from "@/components/library/main/LibHomeSectionNewsletter.vue";
import LibHomeSectionInfo from "@/components/library/main/LibHomeSectionInfo.vue";
import snackbarMixin from "@/mixins/snackbar-mixin.js";
export default {
  name: "Home",
  mixins: [snackbarMixin],
  components: {
    LibHomeSectionBanner,
    LibHomeSectionDesc,
    LibHomeSectionIcons,
    LibHomeSectionNewsletter,
    LibHomeSectionAxis,
    LibHomeSectionInfo
  },
  data: () => {
    return {
      options: {
        duration: 1000,
        offset: 2,
        easing: "linear"
      },
      content: null
    };
  },
  methods: {},
  created() {
    if (this.$route.query.msg) {
      this.snackbar.msg = this.$route.query.msg;
      this.snackbar.show = true;
    }
    if (this.$route.query.complete_registration) {
      let adm = String(this.$route.query.administration);
      if (adm == "false")
        this.$store.commit("layout/showAskDialog", {
          yesClick: () => {
            let props = this.$router.resolve({
              name: "Account"
            });
            let path = window.location.href.split(/[?#]/)[0];
            if (path.endsWith("/")) path = path.slice(0, -1);
            this.$store.dispatch("auth/login", {
              redirectUri: path + props.href
            });
          },
          yesLabel: "Zaloguj",
          noLabel: "Anuluj",
          title: "Potwierdzenie aktywacji konta",
          text: `Twoje konto zostało aktywowane. Możesz rozpocząć pracę w systemie.`
        });
      else {
        this.$store.commit("layout/showAskDialog", {
          yesClick: () => {},
          yesLabel: "OK",
          noLabel: "Anuluj",
          title: "Potwierdzenie aktywacji konta",
          text: `Twoje konto zostało wstępnie aktywowane. Rozpoczęcie pracy w systemie Cyfrowej Książki Obiektu Budowlanego będzie możliwe po jego zatwierdzeniu przez Administratora.`
        });
      }
    }
  }
};
</script>
